var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "linkedin"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 28C21.732 28 28 21.732 28 14C28 6.26801 21.732 0 14 0C6.26801 0 0 6.26801 0 14C0 21.732 6.26801 28 14 28ZM6.26429 22H9.58151V11.3176H6.26429V22ZM6 7.92111C6 8.98185 6.86038 9.86044 7.92111 9.86044C8.98149 9.86044 9.84223 8.98185 9.84223 7.92111C9.84223 7.4116 9.63983 6.92296 9.27955 6.56268C8.91927 6.2024 8.43062 6 7.92111 6C7.4116 6 6.92296 6.2024 6.56268 6.56268C6.2024 6.92296 6 7.4116 6 7.92111ZM18.6867 22H21.9968H22.0004V16.132C22.0004 13.2605 21.3832 11.0498 18.026 11.0498C16.412 11.0498 15.3302 11.9355 14.8873 12.7748H14.8409V11.3176H11.6594V22H14.9731V16.7106C14.9731 15.3177 15.2373 13.9712 16.962 13.9712C18.6617 13.9712 18.6867 15.5606 18.6867 16.7999V22Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.3272174a474dd996c47f595d5923ecce.svg";
export { ForwardRef as ReactComponent };